import React, { useRef } from 'react';
import { t } from '@lingui/macro';

import Bullhorn from '@decisiv/iconix/lib/components/Bullhorn';

import NavMenu from '../NavMenu';
import useWhatsNew from '../../hooks/useWhatsNew';
import WhatsNewPanel from './WhatsNewPanel';

export const PANEL_ENTRY_LIMIT = 5;

export default function WhatsNewMenu() {
  const popoverRef = useRef(null);
  const { entries, unseenCount, markAllSeen } = useWhatsNew();

  return (
    <NavMenu
      emblem={Bullhorn}
      tooltipText={t`What's New`}
      counter={unseenCount}
      childMinWidth="22rem"
      popoverRef={popoverRef}
      onShow={markAllSeen}
    >
      <WhatsNewPanel
        entries={entries.slice(0, PANEL_ENTRY_LIMIT)}
        onSeeAll={() => popoverRef.current?.hide()}
      />
    </NavMenu>
  );
}
